export const ProfileStyle = {
  cardBox: {
    borderRadius: "1rem",
    boxShadow: "3",
    backgroundColor: "white",
  },
  accountImg: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  accountInfo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "90%",
    p: 2,
    mx: "auto",
  },
  profileFont: {
    fontSize: "1.2rem",
    fontWeight: "500",
    my: 2,
  },
  inputIcon: {
    m: 0,
    position: "absolute",
    right: 0,
    width: "17%",
    height: "100%",
    backgroundColor: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderTopRightRadius: "0.3rem",
    borderBottomRightRadius: "0.3rem",
  },
};
